export default {
      id: "fleur-usage",
      viewBox: "0 0 130 125",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#fleur-usage",
      toString: function () {
        return this.url;
      }
    }